<template>
  <el-dialog title="确认提示" :visible.sync="visible" width="450px" :before-close="() => (visible = false)">
    <div class="field-reset-modal">
      <div class="title">
        <span v-if="fieldDetail.system">确定还原系统预设标签的已标注案件吗？</span>
        <span v-else>确定还原自定义标签的已标注案件吗？</span>
      </div>
      <div class="tip-text">
        <span>还原之后，已标注的案件全部变为无标注，请谨慎操作！</span>
      </div>
      <el-radio-group class="radio-content" v-model="mode" v-show="!!fieldDetail.system">
        <div class="radio-li">
          <el-radio label="myself">只还原自己标注的案件</el-radio>
        </div>
        <div class="radio-li">
          <el-radio label="all">一键把已标注案件全部变成未标注案件</el-radio>
        </div>
      </el-radio-group>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">再想想</el-button>
      <el-button type="primary" :loading="loading" @click="confirmHandle">确定还原</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { services } from '@/service';

export default {
  data() {
    return {
      mode: 'myself',
      loading: false
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    courseId: {
      type: String,
      required: true
    },
    fieldDetail: {
      typr: Object,
      required: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        if (this.loading) {
          return;
        }
        this.$emit('update:show', val);
      }
    }
  },
  created() {
    if (!this.fieldDetail.system) {
      this.mode = 'all';
    }
  },
  methods: {
    async confirmHandle() {
      await this.$confirm(`是否确认还原该标签?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      try {
        this.loading = true;

        await services.caseRule.fieldReset({
          operateType: this.mode === 'all' ? 'resetAll' : 'resetOneself',
          coursewareId: this.courseId,
          labelId: this.fieldDetail.columnKey
        });

        this.$emit('success');
        this.loading = false;
        this.visible = false;
      } catch (err) {
        this.loading = false;
        this.$error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.field-reset-modal {
  .title {
    font-size: 16px;
    color: #2c3443;
    line-height: 25px;
  }

  .tip-text {
    font-size: 14px;
    color: #9599a5;
    line-height: 20px;
    margin-top: 3px;
  }

  .radio-content {
    margin-top: 20px;
    .radio-li {
      color: rgba(#3d465a, 0.8);
      margin-top: 7px;

      &:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>
